import { MessageSchema } from "@redotech/redo-agents-common/llm-messages";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

// TODO: If this proves to be the best way to represent a thread in chat, we should move it to the model package.
// But leaving it here for now to test.
export const CustomerAgentThreadSchema = z.object({
  _id: zExt.objectId(),
  updatedAt: z.date(),
  messages: z.array(MessageSchema),
});

export const getCustomerAgentThreads = {
  name: "getCustomerAgentThreads" as const,
  input: z.object({ customerId: z.string() }),
  output: z.object({ threads: z.array(CustomerAgentThreadSchema) }),
};

export const getCustomerAgentThread = {
  name: "getCustomerAgentThread" as const,
  input: z.object({ threadId: zExt.objectId() }),
  output: z.object({ thread: CustomerAgentThreadSchema }),
};
